import { callApi } from "repoV2/utils/common/api/callApi";
import { PAYMENT_PAGES_TYPES } from "repoV2/features/Payments/Payments.constants";
import { appendURLSearchParams } from "repoV2/utils/urls&routing/urlParams";
import {
    CHECKOUT_PAGE_DETAILS_API_ENUMS,
    PAGE_SOURCES_VALUES,
} from "repoV2/features/CheckoutPages/constants/CheckoutPages.constants";
import { checkout_pages_api } from "../CheckoutPages.api";
import {
    IPriceDetails,
    IPriceDetailsApiResponse,
} from "./IPriceDetailsApi.interface";

/**
 * This should be called client side (in a useEffect) cause
 * the price of the listing is dependent upon the geolocation of the user
 * @param object An object containing hostName, and the listing slug or uuid
 * @returns api response
 */
export const callGetCheckoutPagePriceSectionApi = ({
    hostName,
    listingSlug,
    thankyouUuid,
    communityUuid,
    dynamicLinkUuid,
}: {
    hostName: string;
    listingSlug: string;
    thankyouUuid: string;
    communityUuid: string;
    dynamicLinkUuid: string;
}) =>
    callApi({
        url: `${
            checkout_pages_api.checkout_page_details
        }/${hostName}/${listingSlug}${appendURLSearchParams("", {
            section: `${CHECKOUT_PAGE_DETAILS_API_ENUMS.PRICING_SECTION}`,
            page_source: `${PAGE_SOURCES_VALUES.CHECKOUT_PAGE}`,
            ...(thankyouUuid && {
                thankyou_page_uuid: thankyouUuid,
            }),
            ...(communityUuid && {
                community_listing_id: communityUuid,
            }),
            ...(dynamicLinkUuid && {
                dynamic_link_id: dynamicLinkUuid,
                payment_page_type: PAYMENT_PAGES_TYPES.CUSTOM,
            }),
        })}`,
        extraOptions: {
            appendExlyBackendHeaders: true,
        },
    }).then((response: IPriceDetailsApiResponse) => {
        const {
            [CHECKOUT_PAGE_DETAILS_API_ENUMS.PRICING_SECTION]: priceDetails,
        } = response?.data?.data || {};

        const priceDetailsResponse: IPriceDetails = priceDetails;

        return priceDetailsResponse;
    });
